export const EMPTY_CUSTOMER_FORM = {
	name: '',
	webhook_url: '',
	webhook_api_key: '',
	webhook_enabled: false,
	show_branding: true,
	custom_logo: '',
}

export const EMPTY_SENSOR_FORM = {
	sensor_id: '',
	sensor_location: '',
}
